
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-insurance",
      function () {
        return require("private-next-pages/travel-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/travel-insurance"])
      });
    }
  